export default __webpack_public_path__ + "static/media/error-display.779a0750.png";